
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    OnboardingComponent: () =>
      import("@/components/onboarding/OnboardingComponent.vue")
  }
})
export default class Onboarding extends Vue {
  showOnboarding: boolean = false;
  beforeMount() {
    if (this.$store.state.user && this.$store.state.user.id) {
      if (
        ["facebook", "google", "linkedin", "twitter"].some(
          network => this.$store.state.user[`${network}_id`]
        )
      ) {
        this.$router.push({
          name: "Crear cuenta",
          params: { activeStep: "2" }
        });
      } else {
        this.$router.push({ name: "Crear cuenta" });
      }
    } else {
      this.showOnboarding = true;
    }
  }
}
